import { GET_OWNER_LIST } from '../types/types';

const initialState = {
  ownerList: null,
};

const ownerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OWNER_LIST:
      return {
        ...state,
        ownerList: action.payload,
      };
    default:
      return state;
  }
};

export default ownerListReducer;